module.exports = __webpack_public_path__ + "static/media/045-Los Puntos Cantina.5ebbbb53.jpg";